import React from 'react';
import { Trans } from 'lingui-react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import PropTypes from 'utils/prop-types';
import { parseQueryParams } from 'utils/url';

import LoginPage from '../LoginPage';
import { validateSsoTicket } from '../redux/actions';

import messages from './messages';

export function LoginValidation({ location, validateTicket }) {
  const params = parseQueryParams(location.search);

  const ticket = params.ticket;

  if (ticket) {
    // This will kick off the API call to validate our ticket-granting ticket:
    validateTicket(ticket);
    // Once the API call completes successfully, we will be authorized, and that
    // will kick off a router re-render directing the user to the application
    // page that was originally requested.

    return (
      <LoginPage>
        <p><Trans id={messages.validating} /></p>
      </LoginPage>
    );
  }

  // No ticket, so either we're coming back from a logout or something went wrong.
  // In either case, bounce back to the login page.
  return (
    <Redirect to="/login" />
  );
}

LoginValidation.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }).isRequired,
  validateTicket: PropTypes.func.isRequired,
};

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    validateTicket: ticket => dispatch(validateSsoTicket(ticket)),
  };
}

export default connect(undefined, mapDispatchToProps)(LoginValidation);



// WEBPACK FOOTER //
// ./features/authentication/LoginValidation/index.js